import React from "react";

const PaymentsTab = ({ payments }) => {
  return (
    <div>
      <h3 className="text-lg font-bold mb-4">Payments</h3>
      {payments && payments.length > 0 ? (
        <table className="w-full border-collapse text-[#191919]">
          <thead>
            <tr className="bg-[#efefef] border-b border-[#d8d8d8] text-sm">
              <th className="p-3 text-left font-semibold">Payment ID</th>
              <th className="p-3 text-left font-semibold">Date</th>
              <th className="p-3 text-left font-semibold">Status</th>
              <th className="p-3 text-left font-semibold">Amount (₹)</th>
              <th className="p-3 text-left font-semibold">Payment Mode</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((payment, index) => (
              <tr
                key={index}
                className="border-b border-[#d8d8d8] hover:bg-[#ebf8ec] transition text-sm"
              >
                <td className="p-3">{payment.id}</td>
                <td className="p-3">{payment.date}</td>
                <td className="p-3">{payment.status}</td>
                <td className="p-3">{payment.amount}</td>
                <td className="p-3">{payment.mode}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-gray-500 text-sm">No payments available.</p>
      )}
    </div>
  );
};

export default PaymentsTab;
